// extracted by mini-css-extract-plugin
export var animDarkScreen = "style-module--animDarkScreen--45bfc";
export var animTitleFadeIn = "style-module--animTitleFadeIn--4ae2c";
export var darkScreen = "style-module--darkScreen--20673";
export var kvBackground = "style-module--kvBackground--dd3e9";
export var kvLogo = "style-module--kvLogo--9852b";
export var kvVideoSection = "style-module--kvVideoSection--8f81e";
export var kvWrapper = "style-module--kvWrapper--e8b3b";